import React, { useState } from "react";
import { Breadcrumbs, Link, Typography, Collapse, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandMoreIcon from '@mui/icons-material/BreakfastDining';
//import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandLessIcon from '@mui/icons-material/BakeryDining';
import HomeIcon from '@mui/icons-material/Home'; // Icono para el inicio
import useDeviceType from "../hooks/useDeviceType";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Icono para el dropdown

const BreadcrumbsCollapsible = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isPortrait = useDeviceType();

  // Divide la ruta actual en segmentos y elimina los vacíos
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Estado para controlar si los breadcrumbs están colapsados
  const [collapsed, setCollapsed] = useState(pathnames.length > 2);
  const [anchorEl, setAnchorEl] = useState(null); // Estado para el dropdown

  // Función para alternar el colapso
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Función para manejar el menú del dropdown
  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb"
        sx={{
          // Elimina los separadores automáticos
          '& .MuiBreadcrumbs-separator': {
            display: 'none', // Ocultar los separadores
          },
        }}
      >

        {/* COMPUTADORA Si hay más de dos rutas, mostrar el botón de expandir/colapsar */}
        {!isPortrait && pathnames.length > 2 && (
          <IconButton onClick={toggleCollapse} style={{ color: "#ffffff", marginLeft: "8px", backgroundColor: "#222222" }}>
            {!collapsed ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
          </IconButton>
        )}

        {/* Icono home de inicio */}
        <Link
          underline="hover"
          color="#aaaaaa"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <ListItemIcon style={{ minWidth: '24px', color: pathnames.length === 0 ? ("#ffffff") : ("#aaaaaa") }}>
            <HomeIcon fontSize="small" />
          </ListItemIcon>

        </Link>


        {/* Página Inicio */}
        {pathnames.length === 0 ? (  // Si pathnames está vacío, estamos en la raíz
          <Link onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <Typography style={{ color: "#ffffff" }}>Inicio</Typography>
          </Link>
        ) : (
          pathnames.map((value, index) => {
            const isFirst = index === 0; // Primer elemento de la ruta
            const routeTo = `/${pathnames.slice(0, index).join("/")}`;

            return isFirst ? (
              <div style={{ display: "inline-block" }}>
                <Link onClick={() => navigate(routeTo)} style={{ cursor: "pointer" }} key={index}>
                  <Typography color="#aaaaaa" style={{ display: "inline-block" }}>
                    {'Inicio'} {/* Mostrar "Inicio" en el primer breadcrumb */}
                  </Typography>
                </Link>
                {pathnames.length > 2 ? (<>
                  <div style={{ display: !isPortrait && collapsed ? ("inline-block") : ("none") }}>
                    \...
                  </div> {/* Si es mayor a 2 /secciones, si  */}
                </>
                ) : null}
              </div>
            ) : null;
          })
        )}

        {isPortrait && pathnames.length > 2 ? (
          <div>\
            <IconButton onClick={handleDropdownClick} style={{ color: "#aaaaaa", padding: "0px" }}>
              <MoreHorizIcon />
            </IconButton>
          </div>
        ) : (
          <div>{/* Mostrar breadcrumbs con colapso si hay más de dos rutas */}
            <Collapse in={!collapsed}>
              <div style={{ display: collapsed ? ("none") : ("flex"), flexDirection: 'row', flexWrap: 'nowrap' }}>
                {pathnames.map((value, index) => {
                  const isLast = index === pathnames.length - 1;
                  const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;

                  // Se asegura de que no se repita el primer breadcrumb
                  return isLast ? (
                    null
                  ) : (
                    <div>
                      <Link
                        key={index}
                        underline="hover"
                        color="#aaaaaa"
                        onClick={() => navigate(routeTo)}
                        style={{ cursor: "pointer" }}
                      >
                        {/*<ListItemIcon style={{ minWidth: '24px', color: "white" }}>
                      <PersonIcon fontSize="small" />
                    </ListItemIcon>*/}
                        \
                        {decodeURIComponent(value)}
                      </Link>
                    </div>
                  );
                })}
              </div>
            </Collapse></div>
        )}

        {/* Pagina Actual */}
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;

          return isLast ? (
            <Link onClick={() => navigate(routeTo)} style={{ cursor: "pointer" }}>
              <Typography key={index} color="white">
                \{decodeURIComponent(value)}
              </Typography>
            </Link>
          ) : null;
        })}

        {/* Dropdown de los breadcrumbs (solo para dispositivos móviles) */}
        {isPortrait && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseDropdown}
          >
            {pathnames.map((value, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
              return (
                <MenuItem key={index} onClick={() => {
                  navigate(routeTo);
                  handleCloseDropdown(); // Llamar a la función handleCloseDropdown
                }}>

                  {decodeURIComponent(value)}
                </MenuItem>
              );
            })}
          </Menu>
        )}

      </Breadcrumbs>

    </div>
  );
};

export default BreadcrumbsCollapsible;
